import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Sparkles } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/courts", label: "Courts" },
  { to: "/coaching", label: "Coaching" },
  { to: "/membership", label: "Membership" },
  { to: "/members", label: "Member Wall" },
  { to: "/assistant", label: "AI Assistant" },
  { to: "/my-booking", label: "My Booking" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between gap-8">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link" aria-label="The Point Strategy Hub home">
          <span className="w-9 h-9 rounded-full bg-[#ccff00] flex items-center justify-center font-display text-black text-lg">P</span>
          <span className="font-display uppercase tracking-tight text-lg leading-none whitespace-nowrap">
            The Point <span className="text-[#ccff00]">Strategy Hub</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8" aria-label="Main navigation">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm uppercase tracking-widest whitespace-nowrap transition-colors duration-200 ${
                  isActive ? "text-[#ccff00]" : "text-white/70 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={() => navigate("/courts")}
            data-testid="nav-book-cta"
            className="bg-[#ccff00] text-black font-bold text-sm uppercase tracking-wider px-6 py-2.5 rounded-full whitespace-nowrap hover:bg-[#a3e635] hover:-translate-y-0.5 transition-transform duration-200"
          >
            Book a Court
          </button>
        </nav>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-white/10 bg-black/95 px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `text-base uppercase tracking-widest ${isActive ? "text-[#ccff00]" : "text-white/80"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={() => {
              setOpen(false);
              navigate("/courts");
            }}
            className="bg-[#ccff00] text-black font-bold uppercase tracking-wider px-6 py-3 rounded-full flex items-center justify-center gap-2"
          >
            <Sparkles size={16} /> Book a Court
          </button>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
